import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22.286 3.75H1.714A1.714 1.714 0 0 0 0 5.464V19.18a1.714 1.714 0 0 0 1.714 1.714h20.572A1.715 1.715 0 0 0 24 19.179V5.464a1.714 1.714 0 0 0-1.714-1.714ZM20.4 5.464 12 11.276 3.6 5.464h16.8ZM1.714 19.18V6.244l9.797 6.78a.858.858 0 0 0 .978 0l9.797-6.78V19.18H1.714Z",
		fill: "#531DAB"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M22.286%203.75H1.714A1.714%201.714%200%200%200%200%205.464V19.18a1.714%201.714%200%200%200%201.714%201.714h20.572A1.715%201.715%200%200%200%2024%2019.179V5.464a1.714%201.714%200%200%200-1.714-1.714ZM20.4%205.464%2012%2011.276%203.6%205.464h16.8ZM1.714%2019.18V6.244l9.797%206.78a.858.858%200%200%200%20.978%200l9.797-6.78V19.18H1.714Z%22%20fill%3D%22%23531DAB%22%2F%3E%3C%2Fsvg%3E";
